import svgToDataUrl from 'JS/shared/helpers/svgToDataUrl';

export async function parseSvgWidthAndHeight(file) {
  const svgText = await file.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(svgText, 'text/html');
  const svg = doc.querySelector('svg');

  const svgOriginalWidth = svg.getAttribute('width');
  const svgOriginalHeight = svg.getAttribute('height');

  svg.setAttribute('width', parseFloat(svgOriginalWidth));
  svg.setAttribute('height', parseFloat(svgOriginalHeight));

  const svgUrl = svgToDataUrl(svg);
  return await fetch(svgUrl).then(res => res.blob());
}
